import { ORDER_PAY_BASE_URL } from '@/const';
import request from '@/utils/request';
/**
 * 获取支付宝支付token
 * @param params
 */

export function getTokenForBillCheckOut(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    action: '/pay/get-token-for-bill-check-out',
    method: 'POST',
    baseUrl: ORDER_PAY_BASE_URL,
    prefix: '/api/fe',
    params: params
  });
}
/**
 * 获取支付宝根据token获取支付信息
 * @param params
 */

export function billCheckOutByToken(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    action: '/pay/bill-check-out-by-token',
    method: 'GET',
    baseUrl: ORDER_PAY_BASE_URL,
    prefix: '/noRight/api/fe',
    auth: false,
    params: params
  });
}